<button
    class="trigger"
    [class.trigger--open]="isOpen()"
    [class.trigger--error]="isInvalid()"
    cdkOverlayOrigin
    #trigger="cdkOverlayOrigin"
    type="button"
    [disabled]="isDisabled()"
    (click)="toggle()"
>
    <span>{{ displayValue() }}</span>
    <span class="icon-down"></span>
</button>

<ng-template
    cdkConnectedOverlay
    cdkConnectedOverlayPanelClass="app-date-picker-panel"
    cdkConnectedOverlayBackdropClass="cdk-overlay-transparent-backdrop"
    [cdkConnectedOverlayHasBackdrop]="true"
    [cdkConnectedOverlayOrigin]="trigger"
    [cdkConnectedOverlayOpen]="isOpen()"
    [cdkConnectedOverlayPositions]="overlayPositions"
    (backdropClick)="close()"
    (detach)="close()"
>
    <div class="panel">
        <mat-calendar
            [headerComponent]="calendarHeader"
            [selected]="selectedDate()"
            [startAt]="selectedDate()"
            (selectedChange)="onDateSelected($event)"
        ></mat-calendar>
        <div class="panel-time">
            <div class="panel-time__inner">
                <p class="panel-time__label">Time ({{ tzAbbr() }})</p>
                <div class="panel__time">
                    <div class="panel__time-columns">
                        <div
                            class="time-column"
                            tabindex="-1"
                            (click)="selectHour($event)"
                            (keydown)="selectHour($event)"
                        >
                            @for (hour of hours; track hour) {
                                <button
                                    type="button"
                                    class="time-column__item"
                                    [class.time-column__item--selected]="
                                        selectedHour() === hour
                                    "
                                    [attr.data-value]="hour"
                                >
                                    {{ hour | number: "2.0" }}
                                </button>
                            }
                        </div>
                        <div
                            class="time-column"
                            tabindex="-1"
                            (click)="selectMinute($event)"
                            (keydown)="selectMinute($event)"
                        >
                            @for (minute of minutes; track minute) {
                                <button
                                    type="button"
                                    class="time-column__item"
                                    [class.time-column__item--selected]="
                                        selectedMinute() === minute
                                    "
                                    [attr.data-value]="minute"
                                >
                                    {{ minute | number: "2.0" }}
                                </button>
                            }
                        </div>
                    </div>
                    <div class="panel__period">
                        <button
                            type="button"
                            class="period-btn"
                            [class.period-btn--active]="isPM() === false"
                            (click)="setAM()"
                        >
                            AM
                        </button>
                        <button
                            type="button"
                            class="period-btn"
                            [class.period-btn--active]="isPM() === true"
                            (click)="setPM()"
                        >
                            PM
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-template>
